import ApiBase from '../ApiBase';

export default new class extends ApiBase {
    /**
     * @method getMe
     * @return {Promise<*>}
     */
    getMe = () => this.get('me');

    /**
     * @method updateProfile
     * @param {object} data
     * @return {Promise<*>}
     */
    updateProfile = (data) => this.patch('me', data, 'update');

    /**
     * @method updateProfile
     * @param {object} data
     * @return {Promise<*>}
     */
    updatePersonalDetails = (data) => this.patch('me/personal-details', data, 'update');

    /**
     * @method updatePassword
     * @param {string} currentPassword
     * @param {string} newPassword
     * @param {string} passwordConfirmation
     * @return {Promise<*>}
     */
    updatePassword = (currentPassword, newPassword, passwordConfirmation) => this.patch('me/password', {
        current_password: currentPassword,
        new_password: newPassword,
        password_confirmation: passwordConfirmation,
    }, 'update-password');

    /**
     * @method updateAvatar
     * @param {UploadFile} file
     */
    updateAvatar = async (file) => {
        const upload = await this.uploadFile(file);

        if (upload.status !== 200) {
            return upload;
        }

        return this.patch('me/avatar', {
            key: upload.tempKey,
        }, 'avatar-update');
    };

    /**
     * @method stats
     * @returns {Promise<*>}
     */
    stats = () => this.get('me/stats');
};
